import type { FC } from "react";
import styles from "./practiceStyle.module.sass";
import { Button, Card, Col, Row } from "antd";
import Image from "next/image";
import responsiveColumn from "../../../methods/responsiveColumn";
import { useTranslation } from "next-i18next";
import type { PractiseAreaProps } from "./PracticeAreasSection";
import { useRouter } from "next/router";

interface UnOrderedListCompProps {
  openCard: PractiseAreaProps | null;
}

const UnOrderedListComp: FC<UnOrderedListCompProps> = ({ openCard }) => {
  const { t } = useTranslation("practice_groups_home");

  const listArray =
    openCard && openCard.list.split(",").map((item) => item.trim());

  const router = useRouter();

  const LinkHandler = (url: string) => {
    router.push(url);
  };

  return (
    <>
      {openCard ? (
        <Card className={styles.card}>
          <p>{openCard.learn_more}</p>
          <ul className={styles.ulStyle}>
            <Row gutter={[20, 20]}>
              {listArray &&
                listArray.map((item, index) => (
                  <>
                    <Col
                      {...responsiveColumn([12, 12, 12, 24, 24, 24])}
                      className={styles.alignCenter}
                      key={index}
                    >
                      <Row gutter={[16, 16]}>
                        <Col {...responsiveColumn([2, 2, 2, 2, 4, 4])}>
                          <Image
                            src='/Arrow Right.svg'
                            width={24}
                            height={24}
                            alt='unordered list icon'
                            className={styles.imageContain}
                          />
                        </Col>
                        <Col {...responsiveColumn([22, 22, 22, 22, 20, 20])}>
                          <li>
                            <span>{item}</span>
                          </li>
                        </Col>
                      </Row>
                    </Col>
                  </>
                ))}
            </Row>
          </ul>
          <Button
            style={{
              float: "left",
              border: "none",
              background: "none",
              padding: 0,
              marginTop: 40,
            }}
            key={openCard.id}
            onClick={() => LinkHandler(openCard.href)}
          >
            <span
              style={{
                float: "left",
                color: "#254486",
                textDecoration: "underline",
                fontSize: 16,
              }}
            >
              {t("home_section9.section3_started")}
            </span>
          </Button>
        </Card>
      ) : null}
    </>
  );
};

export default UnOrderedListComp;
